module.exports = __webpack_public_path__ + "img/message-sp-2.8d25f313.jpg";